/**
 * @param {import('axios').AxiosInstance} api
 * @param {object} [params]
 * @returns {Promise<object>}
 */
export async function getList(api, params) {
  return (
    await api.get('/rml/admin/AccountDeletionRequests', { params })
  ).data;
}

/**
 * @param {import('axios').AxiosInstance} api
 * @param {string} id
 * @param {'approved'|'rejected'} status
 * @returns {Promise<object>}
 */
export async function updateStatus(api, id, status) {
  return (
    await api.patch(`/rml/admin/AccountDeletionRequests/${id}/status`, {
      status,
    })
  ).data;
}
